import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { MonitorState, AppDispatch } from './monitorStore'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<MonitorState> = useSelector